import 'react-datepicker/dist/react-datepicker.css';
import { Field, Form } from 'react-final-form';
import { Button, ButtonToolbar } from 'reactstrap';
import Alert from '../../../components/notification/Alert';
import RenderVideoRecorder from '../../../components/form/RenderVideoRecorder';
import Icon from '../../../assets/icons/Icon';
import { useState } from 'react';
import { useDict } from '../../../contexts/LanguageContext';

const VideoUpload = (props) => {
    const {
        onSubmit,
        previousPage,
        videoChangedHandler,
        videoErrorSize,
        handleSelection,
        videoMeans,
        videoErrorInvalid,
        isLoading,
        // videoCounter,
    } = props;

    const dict = useDict();

    const [isApiSuccess, setIsApiSuccess] = useState(true);
    const [errorVideo, setErrorVideo] = useState(false);

    return (
        <Form onSubmit={onSubmit}>
            {({ handleSubmit }) => (
                <form
                    className="form form--horizontal wizard__form_2"
                    onSubmit={handleSubmit}
                >
                    {isLoading && (
                        <div className="panel__refresh">
                            <Icon icon="Loading" />
                        </div>
                    )}
                    <div
                        className="form__form-group bottom-border-dashed"
                    >
                        <div
                            className="card__title"
                            style={{ marginBottom: '5px' }}
                        >
                            <h5
                                className="bold-text"
                                style={{ fontSize: '14px' }}
                            >
                                {dict.requiredDocuments}
                            </h5>
                            <h5
                                className="subhead"
                                style={{ fontWeight: 'bold' }}
                            >
                                {dict.videoGuideMessage}
                            </h5>
                        </div>
                    </div>
                    <ButtonToolbar className="form__button-toolbar wizard__toolbar">
                        <div>
                            <button
                                className="next btn btn-outline-primary btn_uni rounded"
                                onClick={() => handleSelection('record')}
                                type="button"
                            >
                                {dict.record}
                            </button>
                        </div>
                        <div>
                            <button
                                className="next btn btn-outline-primary btn_uni rounded"
                                onClick={() => handleSelection('restart')}
                                style={{ marginLeft: '10%', whiteSpace: 'nowrap' }}
                                type="button"
                            >
                                {dict.restart}
                            </button>
                        </div>
                    </ButtonToolbar>
                    {videoMeans === 'record' ? (
                        <div
                            className="form__form-group"
                            style={{ height: '500px' }}
                            data-private
                        >
                            <Field name="video">
                                {({ meta, input }) => (
                                    <RenderVideoRecorder
                                        input={input}
                                        meta={meta}
                                        videoChangedHandler={videoChangedHandler}
                                    />
                                )}
                            </Field>
                        </div>
                    ) : (
                        <div className="form__form-group" />
                    )}
                    {/* {errorVideo && (
                        <Alert color="danger" className="alert--colored" icon>
                            <p style={{ marginTop: '10px' }}>
                                Video EKYC is required. Please upload the video
                            </p>
                        </Alert>
                    )} */}
                    {/* {!isApiSuccess && (
                        <Alert color="danger" className="alert--colored" icon>
                            <p style={{ marginTop: '10px' }}>
                                {videoCounter === 3
                                    ? 'This video does not match the identity document uploaded. However, ' +
                                      'you may continue with registration and someone from the CapBay team will be in touch!'
                                    : 'This video does not match the identity document uploaded. Please re-record your video to proceed!'}
                            </p>
                        </Alert>
                    )} */}
                    {videoErrorSize && (
                        <Alert color="danger" className="alert--colored" icon>
                            <p style={{ marginTop: '10px' }}>
                                {dict.videoSizeErrorMessage}
                            </p>
                        </Alert>
                    )}
                    {videoErrorInvalid && (
                        <Alert color="danger" className="alert--colored" icon>
                            <p style={{ marginTop: '10px' }}>
                                {dict.videoFormatErrorMessage}
                            </p>
                        </Alert>
                    )}
                    <ButtonToolbar className="form__button-toolbar wizard__toolbar">
                        <Button
                            color="primary"
                            type="button"
                            className="previous btn-outline-primary btn_uni rounded"
                            onClick={previousPage}
                        >
                            {dict.back}
                        </Button>
                        <Button
                            type="submit"
                            className={`next btn btn-primary btn_uni rounded ${isLoading && 'disabled'}`}
                            disabled={isLoading}
                        >
                            {dict.next}
                        </Button>
                    </ButtonToolbar>
                </form>
            )}
        </Form>
    );
};

export default VideoUpload;
